import React from 'react'

// TODO: Refactor away when we have i18n
export const DangerouslyRenderHTML: React.FC<{ children: string }> = ({ children }) => {
  return <div dangerouslySetInnerHTML={{ __html: children }} />
}
